import { render, staticRenderFns } from "./NoticeBoardDetail.vue?vue&type=template&id=2cd073e2&scoped=true"
import script from "./NoticeBoardDetail.vue?vue&type=script&lang=js"
export * from "./NoticeBoardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd073e2",
  null
  
)

export default component.exports